import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faPhone from '@fortawesome/fontawesome-free-solid/faPhone';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck';
import faExclamationTriangle from '@fortawesome/fontawesome-free-solid/faExclamationTriangle';

class RegisterPhone extends Component {

  onChange = (e) => {
    this.props.handleChange(e.target.value, 'phone');
  };

  render() {
    const { phone, valid } = this.props;

    return (
      <div className="field is-horizontal">
        <div className="field-label is-medium">
          <label className="label">購買人手機(電話)</label>
        </div>
        <div className="field-body">
          <div className="field">
            <p className="control is-expanded has-icons-left has-icons-right">
              <input
                className={!valid ? 'input' : 'input is-success'}
                type="tel"
                id="register-phone-input"
                placeholder="電話"
                required
                value={phone}
                onChange={this.onChange}
              />
              <span className="icon is-small is-left">
                <FontAwesomeIcon className="icon" icon={faPhone} />
              </span>
              <span className="icon is-small is-right">
                <FontAwesomeIcon
                  className="icon"
                  icon={valid ? faCheck : faExclamationTriangle}
                />
              </span>
            </p>
            <p className="help is-danger">必填</p>
          </div>
        </div>
      </div>
    );
  }
}

RegisterPhone.propTypes = {
  handleChange: PropTypes.func.isRequired,
};

export default RegisterPhone;



// WEBPACK FOOTER //
// ./src/components/RegisterPhone.js